export default function getSurveyWindowTitle(titleEnabled = false, title = '') {
  if (titleEnabled) {
    let surveyTitleText = title;
    if (surveyTitleText.toLowerCase().indexOf('survey') === -1) {
      surveyTitleText += ' Survey';
    }
    return surveyTitleText;
  }
  return 'SurveyMonkey Powered Online Survey';
}
